module.exports = "dist/1042e8ca1ce821518a2d3e7055410839.eot";